import React, { useState } from "react";
import ModalBaseView from "../../../../../../common-deprecated/components/modals/aem/ModalBaseView";
import * as Modal from "../../../../../../common-deprecated/styles/v2/toyota/globals/Modal";
import {
    IconWrapper,
    ToggleIconWrapper,
} from "../../../../../../common-deprecated/styles/v2/toyota/globals/IconWrapper";
import Icon from "../../../../../../common-deprecated/styles/v2/toyota/globals/Icon";
import { BnbLabel } from "../../../utils/labels";
import { useBnbSelector } from "../../../redux/store";
import * as Flex from "../../../../../../common-deprecated/styles/v2/toyota/globals/Flex";
import { ImageFluid } from "../../../../../../common-deprecated/styles/v2/toyota/globals/Image";
import type { SortedSpecType } from "../../../../../../common-deprecated/types/SpecTypes";
import * as Type from "../../../../../../common-deprecated/styles/v2/toyota/globals/Type";
import Popover from "../../../../../../common-deprecated/components/popover/aem/Popover";
import type { GradeEquipmentModalType } from "../../../utils/modalConstants";
import { isRTL } from "../../../../../../common-deprecated/settings/utils/commonSettingUtils";
import type { ModalViewType } from "../../../../../../common-deprecated/types/CommonTypes";
import { useCommonLabel } from "../../../../../../common-deprecated/utils/commonLabels";
import ButtonQuaternary from "../../../../../../common-deprecated/components/aem/toyota/ButtonQuaternary";

/**
 * Modal accepts optional grade prop
 * If a gradeProp is passed, data from that gradeProp must be used instead of
 * the state
 */
const GradeEquipmentModal = (props: ModalViewType<GradeEquipmentModalType>): JSX.Element => {
    const { show, close, modalSettings } = props;

    const {
        gradeName,
        gradeSubtitle: gradeSubTitle,
        mainFeatureEquipment,
        listFeatureEquipment,
        modelName,
    } = modalSettings;

    const commonSettings = useBnbSelector((state) => state.commonSettings);

    const [showListFeatures, setShowListFeatures] = useState<boolean>(false);

    const closeLabel = useCommonLabel("close");

    const subCatList = listFeatureEquipment.filter(
        (category) =>
            Array.isArray(category.subCat) &&
            category.subCat.some((sub) => Array.isArray(sub.data) && sub.data.length > 0),
    );

    return (
        <ModalBaseView modalIdType={modalSettings.type} onClose={close} show={show} size="md">
            <Modal.Header>
                <Modal.Title>
                    <BnbLabel label="standardEquipment" />
                </Modal.Title>
                <Modal.Button type="button" aria-label={closeLabel} onClick={close}>
                    <IconWrapper>
                        <Icon variant="close" />
                    </IconWrapper>
                </Modal.Button>
            </Modal.Header>
            <Modal.Body>
                <Flex.Col width={1} p={0} mb={3} display="flex" flexDirection="column">
                    <div>
                        <Type.ModelName>{modelName}</Type.ModelName>
                        <Type.GradeName ml={1}>{gradeName}</Type.GradeName>
                    </div>
                    <Type.SmallHeading>{gradeSubTitle}</Type.SmallHeading>
                </Flex.Col>
                <Flex.Row>
                    {mainFeatureEquipment.map((equipment) => (
                        <Flex.Col key={equipment.id} width={{ xs: 1, sm: 1 / 2, md: 1 / 2 }} pb={3}>
                            <ImageFluid
                                src={
                                    equipment.image ||
                                    `${commonSettings.resourcePath}/toyota/img/placeholders/800-800.png`
                                }
                                alt={equipment.name}
                            />
                            <Type.Strong pt={2} m={0}>
                                {equipment.name}
                            </Type.Strong>
                        </Flex.Col>
                    ))}
                </Flex.Row>
                {listFeatureEquipment.length > 0 && subCatList.length > 0 && (
                    <Flex.Col
                        display="flex"
                        justifyContent={isRTL(commonSettings) ? "flex-end" : "flex-start"}
                        my={3}
                        px={0}
                    >
                        <ButtonQuaternary hasIconRight onClick={() => setShowListFeatures(!showListFeatures)}>
                            <ToggleIconWrapper isDown={showListFeatures}>
                                <Icon variant="chevronDown" />
                            </ToggleIconWrapper>
                            <BnbLabel label={showListFeatures ? "showLess" : "showMore"} />
                        </ButtonQuaternary>
                    </Flex.Col>
                )}

                {showListFeatures &&
                    listFeatureEquipment
                        .filter((category) => !!category.subCat)
                        .map(({ subCat, id }) => <SpecList specs={subCat!} key={id} />)}
            </Modal.Body>
        </ModalBaseView>
    );
};

const SpecList = ({ specs }: { specs: SortedSpecType[] }): JSX.Element => {
    return (
        <>
            {specs.map((spec) => (
                <Flex.Row key={spec.id} mt={2}>
                    <Flex.Col>
                        <h5>{spec.title}</h5>
                        {!!spec.data &&
                            spec.data.map((catData) => (
                                <Flex.Row key={`${spec.id}-${catData.id}`}>
                                    <Flex.Col position="relative">
                                        {catData.name}
                                        {catData.description && (
                                            <Popover showOnClick content={catData.description} useHTML />
                                        )}
                                    </Flex.Col>
                                </Flex.Row>
                            ))}
                    </Flex.Col>
                </Flex.Row>
            ))}
        </>
    );
};

export default GradeEquipmentModal;
